// import React from 'react'
// import { Button, Card, Form } from 'react-bootstrap'

// function Login() {
//   return (
//     <>
//      <Card style={{ width: '40rem',padding:'20px', margin:'50px auto' }}>
//  <Form>
//       <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
//         <Form.Label>Email address</Form.Label>
//         <Form.Control type="email" placeholder="name@example.com" />
//       </Form.Group>
//       <Form.Label htmlFor="inputPassword5">Password</Form.Label>
//       <Form.Control
//         type="text"
//         id="inputPassword5"
//         aria-describedby="passwordHelpBlock"
//       />
//        <Button className='mt-4' variant="primary">Submit</Button>
//     </Form>
//      </Card>
     
//     </>
//   )
// }

// export default Login


import React, { useState } from 'react'
import { Button, Card, Form } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

function Login() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const handleSubmit =async  (e) => {
    e.preventDefault();

  const res = await fetch("https://appapi.banksstatements.com/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password })
  });

  const data = await res.json();

  if (data.success) {
    localStorage.setItem("isLoggedIn", "true");
    navigate("/phonetracker");
  } else {
    setError('Invalid email or password')
  }
  }

  return (
    <Card style={{ width: '40rem', padding: '20px', margin: '50px auto' }}>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>

        {error && <p style={{ color: 'red' }}>{error}</p>}

        <Button type="submit">Login</Button>
      </Form>
    </Card>
  )
}

export default Login

